import { OptionType } from './AttributesFeed.types';

export const isCompositeOrStatistic = (attribute: OptionType) =>
  attribute.signalType === 'composite' || attribute.signalType === 'statistic';
